import { Inter as loadInterFont } from "next/font/google";
import { AppsFlyerProvider } from "@/providers/onelink";
import { defaultLocale, type Locale } from "@/config";
import type { PageHref } from "@/ui/util";
import Script from "next/script";
import clsx from "clsx";

import "@/ui/theme.css";


// should it be in app/**/layout.tsx?
const interFont = loadInterFont({
  variable: "--font-inter",
  subsets: ["latin"],

  weight: ["300", "400", "500", "600", "700"],
  display: "swap",
});


export function BaseLayout(props: Readonly<{
  locale?: Locale;
  children?: React.ReactNode;
  bodyClassName?: string;
  altHrefs?: { [k in Locale]: PageHref };
}>) {
  return (
    <html lang={props.locale ?? defaultLocale}>
      {/* Bug in NextJS eslint that wants you to use legacy page router <Head> when outside of app */}
      {/* eslint-disable-next-line @next/next/no-head-element */}
      <head>
        <GtmHead />
        <link rel="icon" href="/icon.svg" type="image/svg+xml" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="any" />
        {/*
        @todo
        <link rel="icon" href="/icon.png" type="image/png" sizes="32x32" />
        <link rel="apple-touch-icon" href="/apple-touch-icon.png" />
        */}
        <AppsFlyerProvider />
      </head>
      <body className={clsx(`${interFont.variable} antialiased`, props.bodyClassName)}>
        <GtmBody />
        {props.children}
      </body>
    </html>
  );
}


function GtmHead() {
  return (
    <Script
      id="gtm-init"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GOOGLE_GTM}');`
      }}
    />
  );
}


function GtmBody() {
  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GOOGLE_GTM}`}
        height="0"
        width="0"
        style={{
          display: "none",
          visibility: "hidden",
        }}
      />
    </noscript>
  );
}
